export const SELECT_USER = "@user/SELECT_USER";

export const INITIALIZE_CREATE_USER = "@user/INITIALIZE_CREATE_USER";

export const UPDATE_EMPLOYEE = "@user/UPDATE_EMPLOYEE";
export const UPDATE_ROLE = "@user/UPDATE_ROLE";
export const UPDATE_STATUS = "@user/UPDATE_STATUS";

export const GET_USER_REQUEST = "@user/GET_USER_REQUEST";
export const GET_USER_SUCCESS = "@user/GET_USER_SUCCESS";
export const GET_USER_FAILURE = "@user/GET_USER_FAILURE";

export const GET_DETAIL_USER_REQUEST = "@user/GET_DETAIL_USER_REQUEST";
export const GET_DETAIL_USER_SUCCESS = "@user/GET_DETAIL_USER_SUCCESS";
export const GET_DETAIL_USER_FAILURE = "@user/GET_DETAIL_USER_FAILURE";

export const UPDATE_USER_REQUEST = "@user/UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "@user/UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "@user/UPDATE_USER_FAILURE";

export const CREATE_USER_REQUEST = "@user/CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "@user/CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE = "@user/CREATE_USER_FAILURE";